export default __webpack_public_path__ + "static/media/Grocery-01.c260d952.svg";